import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    {...props}
  >
    <g strokeWidth={1.582}>
      <path
        fill="#e2e7f0"
        d="M16 0c8.864 0 16 6.978 16 15.645S24.864 31.29 16 31.29 0 24.312 0 15.645 7.136 0 16 0"
      />
      <path
        fill="#0e0f10"
        fillOpacity={0.05}
        fillRule="evenodd"
        d="M16 0C7.164 0 0 7.005 0 15.645q0 .792.079 1.565C.882 9.304 7.704 3.127 16 3.127S31.118 9.304 31.921 17.21q.078-.771.079-1.564C32 7.005 24.837 0 16 0"
        clipRule="evenodd"
      />
      <path
        fill="#0e0f10"
        fillOpacity={0.05}
        fillRule="evenodd"
        d="M16 0C7.164 0 0 7.005 0 15.645S7.164 31.29 16 31.29s16-7.005 16-15.645S24.837 0 16 0m0 1.565c-7.953 0-14.4 6.304-14.4 14.08S8.047 29.728 16 29.728s14.4-6.304 14.4-14.081S23.953 1.565 16 1.565"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
const SvgIconRadioButtonEnabled = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconRadioButtonEnabled);
export default Memo;
